import { useSyncExternalStore } from 'react'
import {
  getPresentationVisibility,
  subscribePresentationVisibility,
} from '@/lib/presentation-visibility'

export function usePresentationVisibility() {
  return useSyncExternalStore(
    subscribePresentationVisibility,
    getPresentationVisibility,
    () => true,
  )
}
